import { KatFileUpload } from '@amzn/katal-react';

import { PreviewConstants } from './constants';

enum InputType {
  UPLOAD = 'upload',
  URL = 'url',
  TEXT = 'text',
  DROP_DOWN = 'drop-down',
  DATE_TIME = 'date-time',
}

enum AssetStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING_INPUT = 'PENDING_INPUT',
  PENDING_UPLOAD = 'PENDING_UPLOAD',
}

interface IAssetInputHandler {
  clearError(): void;
  handleFileAttached(fileAttachedEvent: KatFileUpload.FilesAttachedEvent): void;
  handleFileAttachedError(fileAttachedErrorEvent: KatFileUpload.FilesAttachedErrorEvent): void;
  handleFileRemoved(): void;
  handleFileReplaced(fileReplacedEvent: KatFileUpload.FilesReplacedEvent): void;
  handleUrl(urlInput: string): void;
}

interface AssetState {
  key?: string;
  error?: string;
  status: AssetStatus;
}

interface Coordinates {
  x: number;
  y: number;
}

interface StateConfig {
  containerOffset: number;
  logo: { x: number; y: number };
  background: { x: number; y: number };
  overlay: { x: number; y: number };
}

interface PreviewAssets {
  bgImage?: string;
  logo?: string;
  video?: string;
}

type PreviewState =
  (typeof PreviewConstants.PREVIEW_LABELS)[keyof typeof PreviewConstants.PREVIEW_LABELS];

export { AssetStatus, InputType };
export type { IAssetInputHandler, AssetState, PreviewState, StateConfig, PreviewAssets };
